/**
 * @Author : DingHuiHui
 * @Content : 新手包
 */
import $http from '@/utils/requestAxios'
import fetch from '@/utils/fetch2'
const payUrl = process.env.VUE_APP_REPORTURL

export function apiNovice (tenantNo) {
  return $http.get(`npk/${tenantNo}`)
}

/**
 * 支付
 * type: 0 - 支付宝, 1 - 微信, 2 - PayPal
 */
export function apiPay (type, data) {
  const options = { isForm: true }
  let url = payUrl
  console.log(payUrl)
  if (type === 0) {
    url += '/ali/np/pay'
  } else if (type === 1) {
    url += '/wx/np/image'
  } else {
    url += '/paypal/np/pay'
  }
  return fetch.post(url, data, options)
}
